<template>
  <v-row justify="center">
    <v-dialog v-model="orderproductmodal" max-width="900">
      <v-card>
        <v-toolbar height="73" color="white" class="headlinestyle">
          <v-btn icon @click="orderproductmodal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <strong>{{title}}</strong>
          </v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-layout row wrap justify-center>
            <v-flex xs11 sm11 md11 lg11>
              <br />
              <v-layout>
                <v-flex xs12 sm6 md4 lg4>
                  <p style="color:#4C4C4C; font-size:90%;">
                    <strong>รหัสซื้อขาย</strong>
                  </p>
                  <v-text-field
                    v-model="productno_search"
                    outlined
                    clearable
                    dense
                    v-on:input="productfilterfunction()"
                    color="pink lighten-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md5 lg5 px-5>
                  <p style="color:#4C4C4C; font-size:90%;">
                    <strong>ชื่อสินค้า</strong>
                  </p>
                  <v-text-field
                    v-model="name_search"
                    outlined
                    clearable
                    dense
                    v-on:input="productfilterfunction()"
                    color="pink lighten-3"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="allproductdata_view"
                :items-per-page="5"
                class="elevation-1"
                item-key="_id"
                no-data-text
                :footer-props="{
                  itemsPerPageOptions: [5, 10, 20, 50, 100]
                }"
              >
                <template v-slot:item.image="{ item }">
                  <v-img
                    class="white--text align-center"
                    style="height:70px; width:100px;"
                    :src="item.image"
                    v-if="item.image !== ''"
                  ></v-img>
                </template>
                <template v-slot:item.quantity="{ item }">
                  <br />
                  <v-container>
                    <v-text-field
                      class="centered-input"
                      solo
                      dense
                      v-model="item.quantity"
                      type="number"
                      min="0"
                      v-on:input="quantityproduct(item)"
                    ></v-text-field>
                  </v-container>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
        <br />
        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn color="pink" style="margin-right: 5px" outlined @click="cancel()">ยกเลิก</v-btn>

          <v-btn color="pink lighten-2" dark @click="save()">บันทึก</v-btn>
        </v-card-actions>
        <br />
      </v-card>
    </v-dialog>
    <div class="vld-parent">
      <loading :active.sync="isLoading" is-full-page></loading>
    </div>
  </v-row>
</template>

<script>
import { sync } from 'vuex-pathify'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  components: {
    Loading
  },
  data () {
    return {
      title: 'รายการสินค้า',
      allproductdatas: [],
      allproductdata_view: [],
      headers: [
        {
          text: 'รหัสซื้อขาย',
          align: 'center',
          sortable: false,
          value: 'product_no'
        },
        { text: 'รูปสินค้า', align: 'center', sortable: false, value: 'image' },
        { text: 'ชื่อสินค้า', align: 'center', sortable: false, value: 'name' },
        { text: 'ราคา', align: 'center', sortable: false, value: 'price' },
        { text: 'จำนวน', align: 'center', sortable: false, value: 'quantity' },
        { text: 'ประเภท', align: 'center', sortable: false, value: 'type' }
      ],
      selected: [],
      datalength: 0,
      isLoading: false,
      productno_search: '',
      name_search: ''
    }
  },
  methods: {
    async save () {
      try {
        let resultdata = await this.allproductdatas.filter(
          pd => pd.quantity !== 0
        )
        this.currentorderproduct = await JSON.stringify(resultdata)
        this.orderproductmodal = false
        this.productno_search = ''
        this.name_search = ''
      } catch (error) {}
    },
    async getallproductdata () {
      try {
        this.isLoading = true
        let { data } = await axios.get(
          `${process.env.VUE_APP_API}/groupprice/get/customer/${this.currentcustomerid}`,
          {
            headers: {
              Authorization: this.$cookies.get('token')
            }
          }
        )
        this.datalength = data.productitems.length
        if (
          this.currentorderproduct &&
          this.currentgrouppricedata !== '' &&
          this.currentgrouppricedata !== '[]' &&
          this.currentgrouppricedata !== '[{}]'
        ) {
          let selected = JSON.parse(this.currentorderproduct)
          this.allproductdatas = data.productitems.map(pd => {
            let chk = selected.filter(sel => sel._id === pd._id)
            pd.quantity = chk.length !== 0 ? chk[0].quantity : 0
            return { ...pd }
          })
          this.allproductdata_view = this.allproductdatas
        } else {
          this.allproductdatas = data.productitems.map(pd => {
            pd.image = pd.image ? `${process.env.VUE_APP_API}${pd.image}` : ''
            pd.quantity = 0
            return { ...pd }
          })
          this.allproductdata_view = this.allproductdatas
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    cancel () {
      this.orderproductmodal = false
    },
    productfilterfunction () {
      this.allproductdata_view = this.allproductdatas.filter(product => {
        let condition = [
          this.productno_search
            ? product.product_no
              .toLowerCase()
              .includes(this.productno_search.toLowerCase())
            : true,
          this.name_search
            ? product.name
              .toLowerCase()
              .includes(this.name_search.toLowerCase())
            : true
        ]
        return condition.every(con => con)
      })
    },
    quantityproduct (item) {
      this.allproductdatas.map(pd => {
        pd.quantity =
          pd._id === item._id
            ? Number(item.quantity)
            : pd.quantity
              ? Number(pd.quantity)
              : 0
        return { ...pd }
      })
    }
  },
  computed: {
    orderproductmodal: sync('orderproductmodal'),
    currentorderproduct: sync('currentorderproduct'),
    currentcustomerid: sync('currentcustomerid')
  },
  watch: {
    currentorderproduct () {
      let selected = JSON.parse(this.currentorderproduct)
      this.allproductdatas = this.allproductdatas.map(pd => {
        let chk = selected.filter(sel => String(sel._id) === String(pd._id))
        pd.quantity = chk.length !== 0 ? chk[0].quantity : 0
        return { ...pd }
      })
      this.datalength = this.allproductdatas.length
      this.allproductdata_view = this.allproductdatas
    },
    async currentcustomerid () {
      console.log('currentcustomerid', this.currentcustomerid)
      if (this.currentcustomerid !== '') {
        await this.getallproductdata()
      }
    }
  },
  created () {
    // this.getallproductdata()
  }
}
</script>

<style scoped>
.headlinestyle {
  font-family: "Kanit";
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.inputstyle {
  font-family: "Kanit";
  font-style: normal;
  font-weight: normal;
}

.v-text-field {
  font-family: "Kanit";
}
.v-data-table {
  font-family: "Kanit";
}
.v-btn {
  font-family: "Kanit";
  font-weight: bold;
}
td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
</style>

<style>
.centered-input input {
  text-align: center;
}
</style>
